import BaseService from '../base-service.js';

class AuthService extends BaseService {
  constructor() {
    super(''); // Auth endpoints are at root level
  }

  async login(credentials) {
    try {
      const response = await this.post('token/', credentials);
      
      // Transform response to consistent format
      return {
        token: response.token,
        user: response.user || { username: credentials.username },
        permissions: response.permissions || [],
      };
    } catch (error) {
      // Enhance error message
      if (error.status === 400 || error.status === 401) {
        throw {
          ...error,
          message: 'Invalid username or password',
        };
      }
      throw error;
    }
  }

  async getClients() {
    try {
      const response = await this.get('authentication/clients/');
      return response.clients || response;
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  }

  async getAppSettings(appName) {
    try {
      const params = new URLSearchParams(appName ? { app: appName } : {});
      const response = await this.get(`authentication/settings/?${params.toString()}`);
      
      console.log(`✅ Fetched settings${appName ? ` for app: ${appName}` : ''}`, response);
      return response;
    } catch (error) {
      console.error(`❌ Error fetching settings:`, error);
      throw error;
    }
  }

  getCurrentUser() {
    try {
      const userStr = localStorage.getItem('user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      return null;
    }
  }
  
  getToken() {
    return localStorage.getItem('authToken');
  }

  getPermissions() {
    try {
      const permissionsStr = localStorage.getItem('permissions');
      return permissionsStr ? JSON.parse(permissionsStr) : [];
    } catch (error) {
      console.error('Error parsing permissions from localStorage:', error);
      return [];
    }
  }

  clearAuthData() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
  }
}

export default new AuthService();